<app-header [isHome]="isHome"></app-header>
<ion-content scroll-events="true" fullscreen="true"
             (ionScroll)="onScroll($event)">
  <section class="main-banner">
    @defer (hydrate on immediate) {
      <app-home-banner-optimized></app-home-banner-optimized>
    } @placeholder {
              <div class="banner-overlay">
                  <div class="content-wrapper banner-content flex align-items-center">
                    <div class="banner-text">
                      <h1>{{ 'home.banner.title' | translate }}</h1>
                      <p>{{ 'home.banner.description' | translate }}</p>
                      <a class="link-button primary" [routerLink]="['/listing/rent']">{{ 'home.banner.rent_button' | translate }}</a>
                    </div>
                  </div>
                </div>
    }
  </section>
  @if (loadContent) {

    @defer (hydrate on interaction) {
      <section class="search-bar">
        <app-filter></app-filter>
      </section>
    }


    @defer (hydrate on interaction) {
      <app-satel-in-numbers-v2></app-satel-in-numbers-v2>
    }
    @defer (hydrate on interaction) {
      <app-home-about></app-home-about>
    }

    @defer (hydrate on interaction) {
      <app-home-property
        [properties]="properties"
        [loadingProperties]="loadingProperties"
        [propertyPins]="propertyPins"></app-home-property>
    }

    @defer (hydrate on hover) {
      <app-testimonial></app-testimonial>
    } @placeholder {
      <ion-skeleton-text></ion-skeleton-text>
    }


    @defer (hydrate on viewport) {
    <section class="download-app">
      <div class="content-wrapper">
        <div class="flex align-items-center">
          <div class="text-content">
            <h2 class="h2">{{ 'home.download_app.title' | translate }}</h2>
            <p>{{ 'home.download_app.description' | translate }}</p>
            <div class="download-icons">
  <!--            <a><ion-img src="assets/download_apple.webp"></ion-img></a>-->
  <!--            <a><ion-img src="assets/download_android.webp"></ion-img></a>-->
            </div>
<!--            <div class="user-reviews">-->
<!--              <div class="stars">-->
<!--                <ion-icon name="star"></ion-icon>-->
<!--                <ion-icon name="star"></ion-icon>-->
<!--                <ion-icon name="star"></ion-icon>-->
<!--                <ion-icon name="star"></ion-icon>-->
<!--                <ion-icon name="star"></ion-icon>-->
<!--                5.0-->
<!--              </div>-->
<!--              <div class="child">{{ 'home.download_app.reviews' | translate }}</div>-->
<!--            </div>-->

          </div>
          <div class="img-wrapper">
            @defer (when appDownloadImageLoaded) {
              <div class="floating-list">
                <div class="floating-item">
                  <span><ion-text color="secondary">{{ 'home.download_app.manage_properties' | translate }}</ion-text></span>
                </div>
                <div class="floating-item">
                  <span>{{ 'home.download_app.tenant_requests' | translate }}</span>
                </div>
                <div class="floating-item">
                  <span>{{ 'home.download_app.notifications' | translate }}</span>
                </div>
              </div>
            }
            <ion-img (ionImgDidLoad)="appDownloadImageLoaded = true" alt="Satel | Properties in Riyadh" src="./assets/home/img_5.png"></ion-img>
          </div>
        </div>
      </div>
    </section>
    } @placeholder {
      <ion-skeleton-text></ion-skeleton-text>
    }


    @defer (hydrate on viewport) {

    <section class="list-your-property">
      <div class="overlay">
        <div class="text-wrapper">
        <span>{{ 'home.list_property.title' | translate }}</span>
          <p>{{ 'home.list_property.description' | translate }}</p>
          <a class="link-button primary" [routerLink]="['/submit-your-property']">{{ 'home.list_property.button' | translate }}</a>
        </div>
      </div>
      <video  [autoplay]="true" [muted]="true"
              class="ion-hide-sm-down list-your-property-video"
              poster="assets/b2b_banner.webp"
              preload="none"
              fetchpriority="high"
              playsinline loop>
        <source src="https://satel-resources.nyc3.cdn.digitaloceanspaces.com/home-banner/b2b_banner.webm" type="video/webm">
        Your browser does not support the video tag.
      </video>
      <video  [autoplay]="true" [muted]="true"
              class="ion-hide-sm-up list-your-property-video"
              poster="assets/b2b_banner.webp"
              preload="none"
              fetchpriority="high"
              playsinline loop>
        <source src="https://satel-resources.nyc3.cdn.digitaloceanspaces.com/home-banner/b2b_banner.webm" type="video/webm">
        Your browser does not support the video tag.
      </video>
    </section>
    } @placeholder {
      <ion-skeleton-text></ion-skeleton-text>
    }
    <app-footer [showChat]="showChat"></app-footer>
  }
</ion-content>


